import PreferencesManager from "../../../components/sharedcomponents/preferenceManager";
import "../userDashboard.css";

export const UserPreferencePageTag = () => {
  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <PreferencesManager
          showBackButton
          backButtonLink={"/users/preference-category"}
          displayMode="separate"
          activeIndex="tag"
          afterSaveRedirect={"/users/"}
        ></PreferencesManager>
      </div>
    </>
  );
};

export default UserPreferencePageTag;
